/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DashboardResponse } from '../models/DashboardResponse';
import type { FormBlockUpdate } from '../models/FormBlockUpdate';
import type { ServiceRequestCreate } from '../models/ServiceRequestCreate';
import type { ServiceRequestOut } from '../models/ServiceRequestOut';
import type { ServiceRequestUpdate } from '../models/ServiceRequestUpdate';
import type { StatusUpdateRequest } from '../models/StatusUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RequestsService {
    /**
     * Create Service Request
     * @param requestBody
     * @returns ServiceRequestOut Successful Response
     * @throws ApiError
     */
    public static createServiceRequestServiceRequestsPost(
        requestBody: ServiceRequestCreate,
    ): CancelablePromise<ServiceRequestOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/service-requests',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Request
     * @param requestId
     * @param requestBody
     * @returns ServiceRequestOut Successful Response
     * @throws ApiError
     */
    public static updateRequestServiceRequestsRequestIdPatch(
        requestId: number,
        requestBody: ServiceRequestUpdate,
    ): CancelablePromise<ServiceRequestOut> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/service-requests/{request_id}',
            path: {
                'request_id': requestId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Request
     * @param requestId
     * @param requestBody
     * @returns ServiceRequestOut Successful Response
     * @throws ApiError
     */
    public static updateRequestServiceRequestsRequestIdPut(
        requestId: number,
        requestBody: ServiceRequestUpdate,
    ): CancelablePromise<ServiceRequestOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/service-requests/{request_id}',
            path: {
                'request_id': requestId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Request
     * @param requestId
     * @returns void
     * @throws ApiError
     */
    public static deleteRequestServiceRequestsRequestIdDelete(
        requestId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/service-requests/{request_id}',
            path: {
                'request_id': requestId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Patch Form Block
     * @param requestId
     * @param block
     * @param requestBody
     * @returns ServiceRequestOut Successful Response
     * @throws ApiError
     */
    public static patchFormBlockServiceRequestsRequestIdFormDataBlockPatch(
        requestId: number,
        block: string,
        requestBody: FormBlockUpdate,
    ): CancelablePromise<ServiceRequestOut> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/service-requests/{request_id}/form-data/{block}',
            path: {
                'request_id': requestId,
                'block': block,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Request By Id
     * @param requestId
     * @returns ServiceRequestOut Successful Response
     * @throws ApiError
     */
    public static getRequestByIdServiceRequestsRequestRequestIdGet(
        requestId: number,
    ): CancelablePromise<ServiceRequestOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/service-requests/request/{request_id}',
            path: {
                'request_id': requestId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Service Request Status
     * @param requestId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static updateServiceRequestStatusServiceRequestsRequestIdStatusPut(
        requestId: number,
        requestBody: StatusUpdateRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/service-requests/{request_id}/status',
            path: {
                'request_id': requestId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Service Requests
     * @param service
     * @param status
     * @param subStatus
     * @param page
     * @param limit
     * @returns DashboardResponse Successful Response
     * @throws ApiError
     */
    public static listServiceRequestsServiceRequestsDashboardGet(
        service?: (number | null),
        status?: (number | null),
        subStatus?: (number | null),
        page: number = 1,
        limit: number = 20,
    ): CancelablePromise<DashboardResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/service-requests/dashboard',
            query: {
                'service': service,
                'status': status,
                'sub_status': subStatus,
                'page': page,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Unified Metrics
     * @param serviceId
     * @param derivedUserType
     * @returns any Successful Response
     * @throws ApiError
     */
    public static unifiedMetricsServiceRequestsMetricsGet(
        serviceId?: (number | null),
        derivedUserType?: (string | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/service-requests/metrics',
            query: {
                'service_id': serviceId,
                'derived_user_type': derivedUserType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Service Filters
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getServiceFiltersServiceRequestsFiltersGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/service-requests/filters',
        });
    }
}
